import React from 'react'
import { Typography, Form, Col, Input } from 'antd'
import TextArea from 'antd/lib/input/TextArea'

const Title = (props) => {
  return (
    <>
      <Typography.Title>Diamo un titolo al tuo annuncio</Typography.Title>
      <Col xs={24} sm={24} md={24} lg={12}>
        <Form.Item name='titolo'>
          <Input placeholder='Scrivi un titolo per il tuo annuncio (opzionale)' />
        </Form.Item>
        <Form.Item name='descrizione'>
          <TextArea placeholder='Descrizione annuncio (opzionale)' />
        </Form.Item>
      </Col>
    </>
  )
}

export default Title
